module.exports = __webpack_public_path__ + "assets/img/EducationIndex_2.bdf52dab.png";